import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { classed } from '@tw-classed/react'
import { Icon } from '../icon/icon.tsx'

const SubscriptionNotificationWrapper = classed.div(
  'w-full rounded-24 bg-white p-16 font-semibold shadow-drop xl:p-24',
)

const SUBSCRIPTION_NOTIFICATION_STORAGE_KEY =
  'subscriptionNotificationDismissed'

export function SubscriptionNotification() {
  const [isVisible, setIsVisible] = useState(() => {
    if (typeof window === 'undefined') return true
    const dismissed = localStorage.getItem(
      SUBSCRIPTION_NOTIFICATION_STORAGE_KEY,
    )
    return dismissed !== 'true'
  })

  const handleClose = () => {
    setIsVisible(false)
    localStorage.setItem(SUBSCRIPTION_NOTIFICATION_STORAGE_KEY, 'true')
  }

  if (!isVisible) {
    return null
  }

  return (
    <SubscriptionNotificationWrapper>
      <div className="relative">
        <div className="whitespace-pre-wrap pr-32 text-14 leading-6 text-black">
          <span className="inline-flex items-center align-middle">
            <Icon iconName="help" className="mr-4 text-blue5" size="sm" />
          </span>
          <FormattedMessage id="subscription.notification" />
        </div>
        <button
          onClick={handleClose}
          className="absolute right-0 top-0 cursor-pointer text-gray4 transition-colors hover:text-black"
          aria-label="Закрыть уведомление"
        >
          <Icon iconName="close" className="text-current" size="small" />
        </button>
      </div>
    </SubscriptionNotificationWrapper>
  )
}
